var H = require("hogan.js");
module.exports = function() { var T = new H.Template({code: function (c,p,i) { var t=this;t.b(i=i||"");if(t.s(t.f("isDesktop",c,p,1),c,p,0,14,94,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("  <span class=\"tw-clear icon-x\" tabindex=\"0\" aria-label=\"");t.b(t.v(t.d("t.remove",c,p,0)));t.b("\"></span>");t.b("\n" + i);});c.pop();}return t.fl(); },partials: {}, subs: {  }}, "{{#isDesktop}}\n  <span class=\"tw-clear icon-x\" tabindex=\"0\" aria-label=\"{{t.remove}}\"></span>\n{{/isDesktop}}\n", H);return T; }();


//////////////////
// WEBPACK FOOTER
// ./src/frontend/helper/search/helper/templates/partial_clearing.html.mustache
// module id = 100
// module chunks = 2 3